import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/passive-income-calculator',
  component: () => import('../../routes/PassiveIncome.svelte'),
  card: {
    id: 'passive-income-calculator',
    title: 'Passive Income Calculator',
    description: 'Calculate how much capital you need to generate target passive income at any given yield. Based on the 4% rule and FIRE framework.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/passive-income-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Passive Income Calculator – Find How Much Capital You Need',
    description: 'Free passive income calculator. Enter your target monthly income and expected yield to discover how much capital you need to generate it. Based on the 4% rule and FIRE methodology.',
  },
};

export default meta;